const SansmrutiPackages =() => {
    
    return(
        <div>
            <h1>Sansmruthi Publication Home</h1>
        </div>
    )
}
export default SansmrutiPackages;
